import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';

/**
 * Botão de limpar filtros — o único do sistema (achado do Hilton, 02/09/2026: "está fora do
 * padrão do design system").
 *
 * Havia duas aparências opostas para o mesmo gesto: um `<button>` cru com fundo cinza ESCURO
 * e ícone branco aqui, e fundo cinza CLARO com ícone cinza no token. Hoje a aparência vem da
 * classe `.c4u-btn-icon--clear` do CSS — a mesma para todas as telas — e o estado desabilitado
 * é o do próprio botão, não um `opacity` que cada tela punha por fora.
 *
 * O ícone é o ✕ do design system, não o funil cortado (`FilterAltOff`) que estava aqui.
 */
interface ClearFiltersButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
}

const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({
  onClick,
  title = 'Limpar filtros',
  disabled = false,
}) => (
  <Tooltip title={title}>
    <span>
      <IconButton onClick={onClick} disabled={disabled} className="c4u-btn-icon c4u-btn-icon--clear">
        <Close fontSize="small" />
      </IconButton>
    </span>
  </Tooltip>
);

export default ClearFiltersButton;
